import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="brand-logo">
      {!compact && (
        <span className="font-heading font-bold tracking-[0.18em] text-white text-base sm:text-lg">
          PLUS<span className="text-[#D4AF37]">MAKER</span>
        </span>
      )}
    </Link>
  );
}
